import { useMatches } from 'react-router';
import type { RootLoaderData } from '../types/loaders';

export function useRootData() {
  const matches = useMatches();
  const data = matches.find(({ id }) => id === 'root')?.loaderData as RootLoaderData;
  if (!data) {
    throw new Error('must initialize root route data before using useRootData');
  }
  return data;
}
